import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import MuiStepIcon from '@material-ui/core/StepIcon';
import { Check, Edit } from '@ringcentral/juno-icon';
import { combineClasses, styled, useThemeProps, } from '../../../foundation';
import { StepIconStyle } from './styles';
import { StyledCircleIcon } from './styles/StyledCircleIcon';
import { RcStepIconClasses, useIsEditable } from './utils';
var _RcStepIcon = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcStepIcon' });
    var iconProp = props.icon, classesProp = props.classes, editable = props.editable, completed = props.completed, children = props.children, rest = __rest(props, ["icon", "classes", "editable", "completed", "children"]);
    var classes = useMemo(function () { return combineClasses(RcStepIconClasses, classesProp); }, [classesProp]);
    // * get current value again
    var isEdit = useIsEditable(props);
    var icon = useMemo(function () {
        if (editable) {
            return React.createElement(StyledCircleIcon, { isEdit: true, symbol: Edit, size: "small" });
        }
        return completed ? (React.createElement(StyledCircleIcon, { isEdit: isEdit, symbol: isEdit ? Edit : Check, size: "small" })) : (iconProp);
    }, [editable, completed, isEdit, iconProp]);
    return React.createElement(MuiStepIcon, __assign({}, rest, { ref: ref, classes: classes, icon: icon }));
});
/** inner component */
var RcStepIcon = styled(_RcStepIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), StepIconStyle);
RcStepIcon.defaultProps = {};
RcStepIcon.displayName = 'RcStepIcon';
export { RcStepIcon };
var templateObject_1;
